"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Spinner = _interopRequireDefault(require("../Spinner"));
var _Text = _interopRequireDefault(require("../Text"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _utilities = _interopRequireDefault(require("../../utilities"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Modal = _interopRequireDefault(require("../Modal"));
var _ShimmerSsrExperience = _interopRequireDefault(require("../ShimmerSsrExperience"));
var _constant = require("../ShimmerSsrExperience/constant");
var _constant2 = require("./constant");
var _Dropdown = _interopRequireDefault(require("./Dropdown.proptypes"));
var _gtmUtil = require("./gtmUtil");
var _excluded = ["children"];
var _inputWrapperVariants;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// TODO: need to retrive from props

var borderTypes = {
  active: (0, _styledComponents.css)(["border:1px solid ", ";"], function (_ref) {
    var theme = _ref.theme;
    return theme.colors.secondary;
  }),
  nonActive: (0, _styledComponents.css)(["border:1px solid ", ";&:hover{border-color:", ";}"], function (_ref2) {
    var theme = _ref2.theme;
    return theme.colors.greyMedium;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.colors.secondary;
  }),
  nonHighLight: (0, _styledComponents.css)(["border:1px solid ", ";"], function (_ref4) {
    var theme = _ref4.theme;
    return theme.colors.greyMedium;
  }),
  error: (0, _styledComponents.css)(["border:1px solid ", ";"], function (_ref5) {
    var theme = _ref5.theme;
    return theme.colors.orange;
  }),
  holidayMobile: (0, _styledComponents.css)(["border:1px solid ", ";&:hover{border-color:", ";border-bottom:1px solid ", ";}border-bottom:0;"], function (_ref6) {
    var theme = _ref6.theme;
    return theme.colors.greyMedium;
  }, function (_ref7) {
    var theme = _ref7.theme;
    return theme.colors.secondary;
  }, function (_ref8) {
    var theme = _ref8.theme;
    return theme.colors.secondary;
  })
};
var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "Dropdown__Wrapper",
  componentId: "sc-16g04av-0"
})(function (_ref9) {
  var isActive = _ref9.isActive,
    isMobile = _ref9.isMobile,
    error = _ref9.error,
    isNewVersion = _ref9.isNewVersion,
    validateMessage = _ref9.validateMessage,
    validateStatus = _ref9.validateStatus,
    isActiveNewVersion = _ref9.isActiveNewVersion,
    isOnlyApplyForHotel = _ref9.isOnlyApplyForHotel,
    noneHighLight = _ref9.noneHighLight,
    height = _ref9.height,
    isDropdown = _ref9.isDropdown,
    viewPort = _ref9.viewPort,
    holidayMobile = _ref9.holidayMobile;
  var borderType;
  if (isActive && !isNewVersion || isNewVersion && isActiveNewVersion && isActive) {
    borderType = borderTypes.active;
  } else if (error && !isNewVersion && !isDropdown || isNewVersion && validateMessage && validateStatus === _constant2.VALIDATE_STATUS_ERROR) {
    borderType = borderTypes.error;
  } else {
    borderType = borderTypes.nonActive;
  }
  if (noneHighLight) {
    borderType = borderTypes.nonHighLight;
  }
  if (holidayMobile && viewPort === 'mobile') {
    borderType = borderTypes.holidayMobile;
  }
  return (0, _styledComponents.css)(["width:100%;height:", ";border-radius:4px;border:", ";display:flex;justify-content:flex-start;overflow:hidden;box-shadow:", ";", " ", ""], function () {
    if (isNewVersion) return '46px';
    if (height) return height;
    return '56px';
  }, isDropdown && viewPort === 'mobile' ? '1px solid rgb(197, 201, 208)' : '', isNewVersion && isMobile ? 'rgb(0 0 0 / 15%) 0px 2px 6px' : '', !isMobile && borderType, isOnlyApplyForHotel && "margin-top: ".concat(function (theme) {
    return theme.space.small;
  }));
});
var Main = _styledComponents.default.div.withConfig({
  displayName: "Dropdown__Main",
  componentId: "sc-16g04av-1"
})(function (_ref10) {
  var vwPort = _ref10.vwPort,
    vWidth = _ref10.vWidth,
    mWidth = _ref10.mWidth,
    isNewVersion = _ref10.isNewVersion;
  return (0, _styledComponents.css)(["width:", ";min-height:", ";", ";"], vwPort !== 'mobile' && !isNewVersion ? vWidth : mWidth || '100%', function (_ref11) {
    var theme = _ref11.theme;
    return theme.space.large;
  }, vwPort !== 'mobile' && 'position: relative');
});

// TODO: not able to apply theme, need to check

var IconWrapper = _styledComponents.default.div.withConfig({
  displayName: "Dropdown__IconWrapper",
  componentId: "sc-16g04av-2"
})(function (_ref12) {
  var showIconBackground = _ref12.showIconBackground;
  return (0, _styledComponents.css)(["display:flex;flex-direction:column;justify-content:center;padding:0px 0px 0px 12px;", ""], showIconBackground && "background-color: white;");
});
var IconCityWrapper = _styledComponents.default.div.withConfig({
  displayName: "Dropdown__IconCityWrapper",
  componentId: "sc-16g04av-3"
})(function (_ref13) {
  var showIconBackground = _ref13.showIconBackground;
  return (0, _styledComponents.css)(["display:flex;flex-direction:column;justify-content:flex-start;padding-right:", ";", ""], function (_ref14) {
    var theme = _ref14.theme;
    return theme.space.XXSmall;
  }, showIconBackground && "background-color: ".concat(function (_ref15) {
    var theme = _ref15.theme;
    return theme.colors.default;
  }));
});
var CancelIconWrapper = _styledComponents.default.div.withConfig({
  displayName: "Dropdown__CancelIconWrapper",
  componentId: "sc-16g04av-4"
})(function (_ref16) {
  var showIconBackground = _ref16.showIconBackground;
  return (0, _styledComponents.css)(["display:flex;flex-direction:column;justify-content:center;padding:1px 12px 0px 12px;", ""], showIconBackground && "background-color: white;");
});
var inputWrapperVariants = (_inputWrapperVariants = {}, (0, _defineProperty2.default)(_inputWrapperVariants, _constant2.INPUT_VARIANT.focused, (0, _styledComponents.css)(["background:", ";border-color:", ";"], function (_ref17) {
  var theme = _ref17.theme;
  return theme.colors.default;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.colors.secondary;
})), (0, _defineProperty2.default)(_inputWrapperVariants, _constant2.INPUT_VARIANT.error, (0, _styledComponents.css)(["border-color:", ";&:hover{border-color:", ";}"], function (_ref19) {
  var theme = _ref19.theme;
  return theme.colors.orange;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.colors.orange;
})), (0, _defineProperty2.default)(_inputWrapperVariants, _constant2.INPUT_VARIANT.disabled, (0, _styledComponents.css)(["background-color:", ";&:hover{background:", ";border-color:", ";}"], function (_ref21) {
  var theme = _ref21.theme;
  return theme.colors.greyLighter;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.colors.greyLighter;
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.colors.greyLight;
})), _inputWrapperVariants);
var InputWrapper = _styledComponents.default.div.withConfig({
  displayName: "Dropdown__InputWrapper",
  componentId: "sc-16g04av-5"
})(function (_ref24) {
  var variant = _ref24.variant;
  return (0, _styledComponents.css)(["padding-left:", ";position:relative;border-color:", ";background-color:", ";display:flex;flex-direction:row;justify-content:center;align-items:center;width:100%;overflow:hidden;", ""], function (_ref25) {
    var theme = _ref25.theme,
      cityLevelGrouping = _ref25.cityLevelGrouping;
    return cityLevelGrouping ? theme.space.none : theme.space.XSmall;
  }, function (_ref26) {
    var theme = _ref26.theme;
    return theme.colors.greyLight;
  }, function (_ref27) {
    var theme = _ref27.theme;
    return theme.backgroundColor.default;
  }, variant && inputWrapperVariants[variant]);
});
InputWrapper.displayName = 'InputWrapper';
var InputContent = _styledComponents.default.div.withConfig({
  displayName: "Dropdown__InputContent",
  componentId: "sc-16g04av-6"
})(["display:flex;width:100%;flex-direction:column;justify-content:center;"]);
var SmallText = function SmallText(_ref28) {
  var children = _ref28.children,
    rest = (0, _objectWithoutProperties2.default)(_ref28, _excluded);
  return /*#__PURE__*/_react.default.createElement(_Text.default, (0, _extends2.default)({
    accessible: false,
    type: "small"
  }, rest), children);
};
SmallText.propTypes = {
  children: _propTypes.default.node.isRequired
};
var ErrorMessage = (0, _styledComponents.default)(SmallText).withConfig({
  displayName: "Dropdown__ErrorMessage",
  componentId: "sc-16g04av-7"
})(["color:", ";"], function (_ref29) {
  var theme = _ref29.theme;
  return theme.colors.orange;
});
ErrorMessage.displayName = 'ErrorMessage';
var inputLabelVariants = {
  error: (0, _styledComponents.css)(["color:", ";"], function (_ref30) {
    var theme = _ref30.theme;
    return theme.colors.orange;
  })
};
var iconColors = {
  mobile: (0, _styledComponents.css)(["color:#75767a;"]),
  active: (0, _styledComponents.css)(["color:", ";"], function (move) {
    return move ? '#023C40' : '#4b4fa6';
  }),
  nonActive: (0, _styledComponents.css)(["color:#75767a;"]),
  hotelNonActive: (0, _styledComponents.css)(["color:#dadada;"])
};
var CustomIcon = (0, _styledComponents.default)(_Icon.default).withConfig({
  displayName: "Dropdown__CustomIcon",
  componentId: "sc-16g04av-8"
})(function (_ref31) {
  var theme = _ref31.theme,
    isActive = _ref31.isActive,
    isMobile = _ref31.isMobile,
    isOnlyApplyForHotel = _ref31.isOnlyApplyForHotel;
  var color;
  if (isMobile) color = iconColors.mobile;else if (isActive) color = (0, _styledComponents.css)(["color:", ";"], theme.colors.secondary) || iconColors.active;else color = isOnlyApplyForHotel ? iconColors.hotelNonActive : iconColors.nonActive;
  return (0, _styledComponents.css)(["", ""], color);
});
var InputLabel = (0, _styledComponents.default)(SmallText).withConfig({
  displayName: "Dropdown__InputLabel",
  componentId: "sc-16g04av-9"
})(function (_ref32) {
  var variant = _ref32.variant,
    isNewVersion = _ref32.isNewVersion,
    isOnlyApplyForHotel = _ref32.isOnlyApplyForHotel,
    isDropdown = _ref32.isDropdown;
  return (0, _styledComponents.css)(["height:", ";color:", ";opacity:", ";line-height:", ";margin-bottom:", ";outline:none;", ""], function () {
    return isDropdown ? '0px' : '9px';
  }, function (_ref33) {
    var theme = _ref33.theme,
      color = _ref33.color;
    if (color) return theme.colors[color];
    return isOnlyApplyForHotel ? theme.colors.greyDarker : theme.colors.greyDark;
  }, function () {
    return isNewVersion && variant !== _constant2.INPUT_VARIANT.error || isOnlyApplyForHotel ? '0.5' : '';
  }, function (_ref34) {
    var theme = _ref34.theme;
    return theme.lineHeight.XSmall;
  }, function (_ref35) {
    var theme = _ref35.theme;
    return theme.space.micro;
  }, variant && inputLabelVariants[variant]);
});
InputLabel.displayName = 'InputLabel';
var StyledInput = _styledComponents.default.input.withConfig({
  displayName: "Dropdown__StyledInput",
  componentId: "sc-16g04av-10"
})(function (_ref36) {
  var isOnlyApplyForHotel = _ref36.isOnlyApplyForHotel;
  return (0, _styledComponents.css)(["outline:none;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;border:none;font-size:", ";line-height:", ";font-weight:", ";color:", ";&::placeholder{color:", ";opacity:0.5;}&:disabled{background-color:", ";}"], function (_ref37) {
    var theme = _ref37.theme;
    return isOnlyApplyForHotel ? '16px' : theme.fontSize.normal;
  }, function (_ref38) {
    var theme = _ref38.theme;
    return isOnlyApplyForHotel ? '24px' : theme.lineHeight.normal;
  }, function (_ref39) {
    var theme = _ref39.theme;
    return isOnlyApplyForHotel ? '400' : theme.fontWeight.normal;
  }, function (_ref40) {
    var theme = _ref40.theme;
    return theme.colors.neutral;
  }, function (_ref41) {
    var theme = _ref41.theme;
    return theme.colors.greyDark;
  }, function (_ref42) {
    var theme = _ref42.theme;
    return theme.colors.greyLighter;
  });
});
StyledInput.displayName = 'StyledInput';
var getStylesTopValue = function getStylesTopValue(condition, showOptionsfromTop, optionPosition) {
  return showOptionsfromTop ? _constant2.OPTIONS_TOP[condition].topShow : optionPosition === _constant2.TOP ? _constant2.OPTIONS_TOP[condition].bottom : _constant2.OPTIONS_TOP[condition].top;
};
var getOptionsContainerWidth = function getOptionsContainerWidth(width, isNewVersion) {
  if (width && width.indexOf('%') > -1) {
    /* istanbul ignore next */
    return width;
  }
  return isNewVersion ? width : "".concat(parseInt(width.replace('px', ''), 10) + 50, "px");
};
var OptionsContainer = _styledComponents.default.div.withConfig({
  displayName: "Dropdown__OptionsContainer",
  componentId: "sc-16g04av-11"
})(function (_ref43) {
  var vwPort = _ref43.vwPort,
    vWidth = _ref43.vWidth,
    isNewVersion = _ref43.isNewVersion,
    optionPosition = _ref43.optionPosition,
    theme = _ref43.theme,
    showOptionsfromTop = _ref43.showOptionsfromTop,
    cityLevelGrouping = _ref43.cityLevelGrouping;
  var condition = cityLevelGrouping ? _constant2.OPTIONS_CONDITIONS.CITY_LEVEL : _constant2.OPTIONS_CONDITIONS.DEFAULT;
  return (0, _styledComponents.css)(["position:absolute;", " display:flex;flex-direction:column;width:", ";border-radius:4px;background-color:", ";", " z-index:1000;"], getStylesTopValue(condition, showOptionsfromTop, optionPosition), vwPort !== 'mobile' && !isNewVersion ? getOptionsContainerWidth(vWidth, isNewVersion) : vWidth, theme.backgroundColor.default, vwPort !== 'mobile' && "\n      box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.16);\n      border: 1px solid ".concat(theme.colors.greyLight, ";\n    "));
});
var Divider = _styledComponents.default.div.withConfig({
  displayName: "Dropdown__Divider",
  componentId: "sc-16g04av-12"
})(["height:1px;background:", ";margin-left:", ";margin-right:", ";z-index:2;"], function (_ref44) {
  var theme = _ref44.theme;
  return theme.colors.greyLight;
}, function (_ref45) {
  var theme = _ref45.theme;
  return theme.space.XXXSmall;
}, function (_ref46) {
  var theme = _ref46.theme;
  return theme.space.XXXSmall;
});
var OptionsWrapper = _styledComponents.default.ul.withConfig({
  displayName: "Dropdown__OptionsWrapper",
  componentId: "sc-16g04av-13"
})(function (_ref47) {
  var vwPort = _ref47.vwPort,
    isNewVersion = _ref47.isNewVersion,
    isDropdown = _ref47.isDropdown,
    cityLevelGrouping = _ref47.cityLevelGrouping;
  return (0, _styledComponents.css)(["overflow-y:auto;overflow-x:hidden;list-style:none;margin:", ";padding:", ";background-color:", ";", ";margin-top:", ";min-width:", ";", ";"], function (_ref48) {
    var theme = _ref48.theme;
    return theme.space.none;
  }, function (_ref49) {
    var theme = _ref49.theme;
    return theme.space.none;
  }, function (_ref50) {
    var theme = _ref50.theme,
      bgColor = _ref50.bgColor;
    if (bgColor) return theme.colors[bgColor];
    return isNewVersion || isDropdown || cityLevelGrouping ? theme.colors.default : theme.backgroundColor.primary;
  }, vwPort !== 'mobile' && cityLevelGrouping ? 'max-height: 476px' : vwPort !== 'mobile' && !cityLevelGrouping ? 'max-height: 252px;' : 'max-height: 100vh;', function (_ref51) {
    var theme = _ref51.theme;
    return theme.space.micro;
  }, isNewVersion && vwPort === 'desktop' ? '300px' : 'unset', isNewVersion ? "\n    -ms-overflow-style: none; /* Internet Explorer 10+ */\n    scrollbar-width: none; /* Firefox */\n    ::-webkit-scrollbar {\n      display: none; /* Safari and Chrome */\n      }" : "");
});
var activeOption = {
  active: (0, _styledComponents.css)(["background:", ";border-color:", ";"], function (_ref52) {
    var theme = _ref52.theme,
      isNewVersion = _ref52.isNewVersion;
    return isNewVersion ? theme.colors.greyLighter : theme.colors.default;
  }, function (_ref53) {
    var theme = _ref53.theme;
    return theme.colors.secondary;
  })
};
var Option = _styledComponents.default.li.withConfig({
  displayName: "Dropdown__Option",
  componentId: "sc-16g04av-14"
})(function (_ref54) {
  var isActive = _ref54.isActive;
  return (0, _styledComponents.css)(["display:flex;cursor:pointer;flex-direction:", ";justify-content:space-between;width:100%;min-height:56px;background:", ";", ";&:hover{background:", ";border-color:", ";}"], function (_ref55) {
    var cityLevelGrouping = _ref55.cityLevelGrouping;
    return cityLevelGrouping ? 'column' : 'row';
  }, function (_ref56) {
    var cityLevelGrouping = _ref56.cityLevelGrouping;
    return cityLevelGrouping && 'none';
  }, isActive ? activeOption.active : '', function (_ref57) {
    var theme = _ref57.theme,
      isNewVersion = _ref57.isNewVersion;
    return isNewVersion ? theme.colors.greyLighter : theme.colors.default;
  }, function (_ref58) {
    var theme = _ref58.theme;
    return theme.colors.secondary;
  });
});
var OptionDeep = _styledComponents.default.li.withConfig({
  displayName: "Dropdown__OptionDeep",
  componentId: "sc-16g04av-15"
})(function (_ref59) {
  var isActive = _ref59.isActive;
  return (0, _styledComponents.css)(["padding-left:", ";padding-top:", ";display:flex;cursor:pointer;flex-direction:row;justify-content:space-between;min-height:56px;text-transform:", ";background:", ";", ";&:hover{background:", ";border-color:", ";}"], function (_ref60) {
    var theme = _ref60.theme,
      isCity = _ref60.isCity;
    return isCity ? theme.space.semiSmall : theme.space.semiMedium;
  }, function (_ref61) {
    var theme = _ref61.theme,
      isCity = _ref61.isCity;
    return isCity ? theme.space.none : theme.space.micro;
  }, function (_ref62) {
    var cityLevelGrouping = _ref62.cityLevelGrouping;
    return cityLevelGrouping ? 'none' : 'capitalize';
  }, function (_ref63) {
    var theme = _ref63.theme;
    return theme.colors.default;
  }, isActive ? activeOption.active : '', function (_ref64) {
    var theme = _ref64.theme;
    return theme.colors.greyLighter;
  }, function (_ref65) {
    var theme = _ref65.theme;
    return theme.colors.secondary;
  });
});
var OptionLeft = _styledComponents.default.div.withConfig({
  displayName: "Dropdown__OptionLeft",
  componentId: "sc-16g04av-16"
})(["display:flex;flex-direction:row;"]);
var OptionRight = _styledComponents.default.div.withConfig({
  displayName: "Dropdown__OptionRight",
  componentId: "sc-16g04av-17"
})(["display:flex;flex-direction:column;justify-content:center;padding-right:", ";padding-left:", ";align-items:flex-end;"], function (_ref66) {
  var theme = _ref66.theme;
  return theme.space.XXXSmall;
}, function (_ref67) {
  var theme = _ref67.theme;
  return theme.space.XXSmall;
});
var OptionContent = _styledComponents.default.div.withConfig({
  displayName: "Dropdown__OptionContent",
  componentId: "sc-16g04av-18"
})(["display:flex;flex-direction:column;justify-content:center;padding-left:", ";"], function (_ref68) {
  var theme = _ref68.theme,
    cityLevelGrouping = _ref68.cityLevelGrouping;
  return cityLevelGrouping ? theme.space.none : theme.space.XSmall;
});
var GroupWrapper = _styledComponents.default.div.withConfig({
  displayName: "Dropdown__GroupWrapper",
  componentId: "sc-16g04av-19"
})(["display:flex;flex-direction:row;justify-content:center;font-family:", ";"], function (_ref69) {
  var theme = _ref69.theme;
  return theme.fontFamily.default;
});
var CityWrapper = _styledComponents.default.div.withConfig({
  displayName: "Dropdown__CityWrapper",
  componentId: "sc-16g04av-20"
})(["display:flex;flex-direction:row;font-family:", ";font-size:", ";"], function (_ref70) {
  var theme = _ref70.theme;
  return theme.fontFamily.default;
}, function (_ref71) {
  var theme = _ref71.theme,
    isCity = _ref71.isCity;
  return isCity ? theme.fontSize.normal : theme.fontSize.small;
});
var FlexWrapper = _styledComponents.default.div.withConfig({
  displayName: "Dropdown__FlexWrapper",
  componentId: "sc-16g04av-21"
})(["display:flex;align-items:center;"]);
var OptionMainContent = _styledComponents.default.div.withConfig({
  displayName: "Dropdown__OptionMainContent",
  componentId: "sc-16g04av-22"
})(function (_ref72) {
  var color = _ref72.color;
  return (0, _styledComponents.css)(["line-height:", ";font-size:", ";color:", ";font-family:", ";padding-right:", ";"], function (_ref73) {
    var theme = _ref73.theme;
    return theme.lineHeight.normal;
  }, function (_ref74) {
    var theme = _ref74.theme;
    return theme.fontSize.normal;
  }, function (_ref75) {
    var theme = _ref75.theme;
    return theme.colors[color] || theme.colors.neutral;
  }, function (_ref76) {
    var theme = _ref76.theme;
    return theme.fontFamily.default;
  }, function (_ref77) {
    var theme = _ref77.theme,
      cityLevelGrouping = _ref77.cityLevelGrouping;
    return cityLevelGrouping ? theme.space.none : theme.space.micro;
  });
});
var OptionSubContent = _styledComponents.default.div.withConfig({
  displayName: "Dropdown__OptionSubContent",
  componentId: "sc-16g04av-23"
})(function (_ref78) {
  var icName = _ref78.icName;
  return (0, _styledComponents.css)(["line-height:", ";font-size:", ";color:", ";font-family:", ";", ""], function (_ref79) {
    var theme = _ref79.theme;
    return theme.lineHeight.small;
  }, function (_ref80) {
    var theme = _ref80.theme;
    return theme.fontSize.XSmall;
  }, function (_ref81) {
    var theme = _ref81.theme;
    return theme.colors.greyDark;
  }, function (_ref82) {
    var theme = _ref82.theme;
    return theme.fontFamily.default;
  }, icName && 'background: #F8F8F8');
});
var OptionCityContent = _styledComponents.default.div.withConfig({
  displayName: "Dropdown__OptionCityContent",
  componentId: "sc-16g04av-24"
})(function () {
  return (0, _styledComponents.css)(["line-height:", ";font-size:", ";color:", ";font-family:", ";font-weight:", ";"], function (_ref83) {
    var theme = _ref83.theme;
    return theme.lineHeight.small;
  }, function (_ref84) {
    var theme = _ref84.theme;
    return theme.fontSize.small;
  }, function (_ref85) {
    var theme = _ref85.theme;
    return theme.colors.secondary;
  }, function (_ref86) {
    var theme = _ref86.theme;
    return theme.fontFamily.default;
  }, function (_ref87) {
    var theme = _ref87.theme;
    return theme.fontWeight.medium;
  });
});
var OptionSubRightContent = _styledComponents.default.div.withConfig({
  displayName: "Dropdown__OptionSubRightContent",
  componentId: "sc-16g04av-25"
})(function () {
  return (0, _styledComponents.css)(["line-height:", ";font-size:", ";color:", ";font-family:", ";background:", ";padding:", ";borderradius:", ";"], function (_ref88) {
    var theme = _ref88.theme;
    return theme.lineHeight.small;
  }, function (_ref89) {
    var theme = _ref89.theme;
    return theme.fontSize.XSmall;
  }, function (_ref90) {
    var theme = _ref90.theme,
      move = _ref90.move;
    return move ? theme.colors.secondary : theme.colors.secondaryDark;
  }, function (_ref91) {
    var theme = _ref91.theme;
    return theme.fontFamily.default;
  }, function (_ref92) {
    var theme = _ref92.theme;
    return theme.colors.secondaryLight;
  }, function (_ref93) {
    var theme = _ref93.theme;
    return "".concat(theme.space.mini, " ").concat(theme.space.xtiny);
  }, function (_ref94) {
    var theme = _ref94.theme;
    return theme.space.small;
  });
});
var MobilePopup = _styledComponents.default.div.withConfig({
  displayName: "Dropdown__MobilePopup",
  componentId: "sc-16g04av-26"
})(["position:", ";overflow:", ";width:100%;background-color:", ";height:100%;top:0px;left:0px;z-index:100;"], function (_ref95) {
  var isNewVersion = _ref95.isNewVersion,
    isDropdown = _ref95.isDropdown;
  return isDropdown ? 'relative' : isNewVersion ? 'fixed' : 'absolute';
}, function (_ref96) {
  var isNewVersion = _ref96.isNewVersion;
  return isNewVersion ? 'auto' : 'unset';
}, function (_ref97) {
  var theme = _ref97.theme;
  return theme.backgroundColor.default;
});
var PopupHeader = _styledComponents.default.div.withConfig({
  displayName: "Dropdown__PopupHeader",
  componentId: "sc-16g04av-27"
})(["width:100%;height:56px;position:", ";display:flex;flex-direction:row;font-family:", ";z-index:50;background-color:", ";border:", ";border-radius:", ";"], function (_ref98) {
  var isDropdown = _ref98.isDropdown,
    isPlacePickerDropdown = _ref98.isPlacePickerDropdown;
  return isDropdown ? 'relative' : isPlacePickerDropdown ? 'absolute' : 'fixed';
}, function (_ref99) {
  var theme = _ref99.theme;
  return theme.fontFamily.default;
}, function (_ref100) {
  var theme = _ref100.theme;
  return theme.backgroundColor.default;
}, function (_ref101) {
  var theme = _ref101.theme,
    isPlacePickerDropdown = _ref101.isPlacePickerDropdown;
  return isPlacePickerDropdown && "1px solid  ".concat(theme.colors.greyMedium);
}, function (_ref102) {
  var theme = _ref102.theme,
    isPlacePickerDropdown = _ref102.isPlacePickerDropdown;
  return isPlacePickerDropdown && theme.space.micro;
});
var RecentSearches = _styledComponents.default.div.withConfig({
  displayName: "Dropdown__RecentSearches",
  componentId: "sc-16g04av-28"
})(["display:flex;flex-direction:column;justify-content:center;padding-left:", ";font-family:", ";height:", ";background-color:", ";"], function (_ref103) {
  var theme = _ref103.theme;
  return theme.space.small;
}, function (_ref104) {
  var theme = _ref104.theme;
  return theme.fontFamily.default;
}, function (_ref105) {
  var theme = _ref105.theme;
  return theme.lineHeight.titleSmall;
}, function (_ref106) {
  var theme = _ref106.theme,
    cityLevelGrouping = _ref106.cityLevelGrouping;
  return cityLevelGrouping && theme.backgroundColor.greyLighter;
});
var MobileText = _styledComponents.default.div.withConfig({
  displayName: "Dropdown__MobileText",
  componentId: "sc-16g04av-29"
})(["color:", ";font-family:", ";overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding-right:", ";"], function (_ref107) {
  var theme = _ref107.theme,
    isOnlyApplyForHotel = _ref107.isOnlyApplyForHotel,
    hasValue = _ref107.hasValue,
    color = _ref107.color,
    allowPlaceholderColorMobile = _ref107.allowPlaceholderColorMobile;
  if (allowPlaceholderColorMobile && color) return theme.colors[color];
  return isOnlyApplyForHotel && !hasValue ? theme.colors.greyDarker : theme.colors.black;
}, function (_ref108) {
  var theme = _ref108.theme;
  return theme.fontFamily.default;
}, function (_ref109) {
  var theme = _ref109.theme,
    cityLevelGrouping = _ref109.cityLevelGrouping;
  return cityLevelGrouping && theme.space.standard;
});
var MobileV2Text = _styledComponents.default.div.withConfig({
  displayName: "Dropdown__MobileV2Text",
  componentId: "sc-16g04av-30"
})(["font-family:", ";overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:", ";opacity:", ";"], function (_ref110) {
  var theme = _ref110.theme;
  return theme.fontFamily.default;
}, function (_ref111) {
  var theme = _ref111.theme,
    hasValue = _ref111.hasValue,
    color = _ref111.color,
    allowPlaceholderColorMobile = _ref111.allowPlaceholderColorMobile;
  if (allowPlaceholderColorMobile && color) return theme.colors[color];
  return !hasValue ? theme.colors.greyDark : '';
}, function (_ref112) {
  var hasValue = _ref112.hasValue;
  return !hasValue ? '0.5' : '';
});
var LoadingOptions = _styledComponents.default.div.withConfig({
  displayName: "Dropdown__LoadingOptions",
  componentId: "sc-16g04av-31"
})(["display:flex;flex-direction:row;justify-content:", ";line-height:", ";padding:", ";font-family:", ";font-size:", ";color:", ";"], function (_ref113) {
  var isNewVersion = _ref113.isNewVersion;
  return isNewVersion ? 'flex-start' : 'center';
}, function (_ref114) {
  var theme = _ref114.theme;
  return theme.lineHeight.normal;
}, function (_ref115) {
  var theme = _ref115.theme,
    cityLevelGrouping = _ref115.cityLevelGrouping,
    noOptions = _ref115.noOptions;
  return cityLevelGrouping && !noOptions ? theme.space.none : theme.space.XSmall;
}, function (_ref116) {
  var theme = _ref116.theme;
  return theme.fontFamily.default;
}, function (_ref117) {
  var theme = _ref117.theme,
    isNewVersion = _ref117.isNewVersion;
  return isNewVersion ? theme.fontSize.small : theme.fontFamily.normal;
}, function (_ref118) {
  var theme = _ref118.theme,
    isNewVersion = _ref118.isNewVersion;
  return isNewVersion ? theme.colors.greyDark : theme.colors.neutral;
});
var OptionAirportCode = _styledComponents.default.span.withConfig({
  displayName: "Dropdown__OptionAirportCode",
  componentId: "sc-16g04av-32"
})(["margin-left:4px;"]);
var HighLightText = _styledComponents.default.span.withConfig({
  displayName: "Dropdown__HighLightText",
  componentId: "sc-16g04av-33"
})(["line-height:", ";font-size:17px;font-weight:1000;color:", ";font-family:", ";"], function (_ref119) {
  var theme = _ref119.theme;
  return theme.lineHeight.normal;
}, function (_ref120) {
  var theme = _ref120.theme;
  return theme.colors.black;
}, function (_ref121) {
  var theme = _ref121.theme;
  return theme.fontFamily.default;
});
var NonHighLightText = _styledComponents.default.span.withConfig({
  displayName: "Dropdown__NonHighLightText",
  componentId: "sc-16g04av-34"
})(["line-height:", ";font-size:", ";color:", ";font-family:", ";text-transform:none;"], function (_ref122) {
  var theme = _ref122.theme;
  return theme.lineHeight.normal;
}, function (_ref123) {
  var theme = _ref123.theme;
  return theme.fontSize.normal;
}, function (_ref124) {
  var theme = _ref124.theme;
  return theme.colors.neutral;
}, function (_ref125) {
  var theme = _ref125.theme;
  return theme.fontFamily.default;
});
var DropdownIcon = _styledComponents.default.div.withConfig({
  displayName: "Dropdown__DropdownIcon",
  componentId: "sc-16g04av-35"
})(["max-width:20px;max-height:20px;position:absolute;right:", ";"], function (_ref126) {
  var theme = _ref126.theme;
  return theme.space.XSmall;
});
var SuggestionOverlay = _styledComponents.default.div.withConfig({
  displayName: "Dropdown__SuggestionOverlay",
  componentId: "sc-16g04av-36"
})(["position:absolute;bottom:3;left:3.1;padding-top:12.5px;padding-left:1.5px;font-size:1tem;font-family:", ";line-height:", ";color:gray;z-index:1;pointer-events:none;white-space:pre;display:flex;align-items:center;"], function (_ref127) {
  var theme = _ref127.theme;
  return theme.fontFamily.default;
}, function (_ref128) {
  var theme = _ref128.theme;
  return theme.lineHeight.normal;
});
var OptionContentView = function OptionContentView(_ref129) {
  var color = _ref129.color,
    mainDisplayName = _ref129.mainDisplayName,
    airportCode = _ref129.airportCode,
    subDisplayName = _ref129.subDisplayName,
    AirportName = _ref129.AirportName,
    CountryName = _ref129.CountryName,
    iconName = _ref129.iconName,
    inputValue = _ref129.inputValue,
    highlightText = _ref129.highlightText,
    cityLevelGrouping = _ref129.cityLevelGrouping,
    CityName = _ref129.CityName,
    isCity = _ref129.isCity,
    locale = _ref129.locale;
  var searchStringToGenerate = function searchStringToGenerate() {
    var search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var primaryText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var defaultText = [{
      text: primaryText
    }];
    if (typeof search === 'string' && search !== '' && typeof primaryText === 'string' && primaryText !== '') {
      var searchStringToPrimary = primaryText.toLowerCase().indexOf(search.toLowerCase());
      // we will divide the string so we can map it to form a whole string with highlighted search

      var firstWord = primaryText.substring(0, searchStringToPrimary);
      var middle = primaryText.substring(searchStringToPrimary, searchStringToPrimary + search.length);
      var lastWord = primaryText.substring(searchStringToPrimary + search.length, primaryText.length);
      if (searchStringToPrimary > 0) {
        // if our search string has a index of greater than to 0 it means we can divide our text to 3
        return [{
          text: firstWord
        }, {
          text: middle,
          isHighlight: true
        }, {
          text: lastWord
        }];
      }
      if (searchStringToPrimary === 0) {
        return [{
          text: middle,
          isHighlight: true
        }, {
          text: lastWord
        }];
      }
      return defaultText;
    }
    // always return the default option text if the above conditions are not met
    return [{
      text: primaryText
    }];
  };
  var wordsWithHight = searchStringToGenerate(inputValue, mainDisplayName);
  var defaultContent = function defaultContent() {
    return /*#__PURE__*/_react.default.createElement(OptionContent, null, /*#__PURE__*/_react.default.createElement(OptionMainContent, {
      color: color
    }, highlightText ? wordsWithHight.map(function (strItem) {
      if (strItem.isHighlight) {
        return /*#__PURE__*/_react.default.createElement(HighLightText, {
          key: strItem.text
        }, strItem.text);
      }
      return /*#__PURE__*/_react.default.createElement(NonHighLightText, {
        key: strItem.text
      }, strItem.text);
    }) : /*#__PURE__*/_react.default.createElement(NonHighLightText, null, mainDisplayName), airportCode && /*#__PURE__*/_react.default.createElement(OptionAirportCode, null, airportCode)), subDisplayName && /*#__PURE__*/_react.default.createElement(OptionSubContent, null, subDisplayName));
  };
  var cityLevelContent = function cityLevelContent() {
    var allAirportsLabel = locale && locale.allAirports ? locale.allAirports : _constant2.ALL_AIRPORTS;
    return /*#__PURE__*/_react.default.createElement(GroupWrapper, null, /*#__PURE__*/_react.default.createElement(IconCityWrapper, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: iconName,
      fontsize: _constant2.ICON_STYLE.SIZE,
      color: _constant2.ICON_STYLE.COLOR_DEFAULT
    })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(CityWrapper, {
      isCity: isCity
    }, isCity || AirportName === '' ? "".concat(CityName, " ").concat(allAirportsLabel) : AirportName), /*#__PURE__*/_react.default.createElement(FlexWrapper, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: false,
      type: _constant2.TEXT_TYPE.SMALL,
      color: _constant2.TEXT_COLOR.GREY
    }, CountryName))));
  };
  return cityLevelGrouping ? cityLevelContent() : defaultContent();
};

// TODO: need to check icon color and icon position
var Dropdown = function Dropdown(props) {
  var defaultValue = props.defaultValue,
    onChange = props.onChange,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    theme = props.theme,
    customProperties = props.customProperties,
    className = props.className,
    validateStatus = props.validateStatus,
    alwaysShowLabel = props.alwaysShowLabel,
    label = props.label,
    _props$accessible = props.accessible,
    accessible = _props$accessible === void 0 ? false : _props$accessible,
    items = props.items,
    onSelect = props.onSelect,
    placeHolder = props.placeHolder,
    viewPort = props.viewPort,
    defaultIcon = props.defaultIcon,
    locale = props.locale,
    width = props.width,
    id = props.id,
    placeHolderItems = props.placeHolderItems,
    isFocused = props.isFocused,
    recentSearchIcon = props.recentSearchIcon,
    _props$inputRef = props.inputRef,
    inputRef = _props$inputRef === void 0 ? (0, _react.useRef)(null) : _props$inputRef,
    _props$supportOneChar = props.supportOneCharacterSearch,
    supportOneCharacterSearch = _props$supportOneChar === void 0 ? false : _props$supportOneChar,
    mWidth = props.mWidth,
    isValidField = props.isValidField,
    qpSyncStations = props.qpSyncStations,
    isNewVersion = props.isNewVersion,
    hideMobileIcon = props.hideMobileIcon,
    validateMessage = props.validateMessage,
    onClickCallback = props.onClickCallback,
    highlightText = props.highlightText,
    customDisplayValue = props.customDisplayValue,
    customDisplayField = props.customDisplayField,
    isOnlyApplyForHotel = props.isOnlyApplyForHotel,
    showIconBackground = props.showIconBackground,
    isShowCancel = props.isShowCancel,
    onClear = props.onClear,
    autoSelectOneResult = props.autoSelectOneResult,
    showOptionsfromTop = props.showOptionsfromTop,
    cancelIconColor = props.cancelIconColor,
    hideLabelWhenFocus = props.hideLabelWhenFocus,
    backgroundColorItems = props.backgroundColorItems,
    noneHighLightInput = props.noneHighLightInput,
    showSearchFor = props.showSearchFor,
    hideRecentLabel = props.hideRecentLabel,
    height = props.height,
    allowPlaceholderColorMobile = props.allowPlaceholderColorMobile,
    hotelIcon = props.hotelIcon,
    isDropdown = props.isDropdown,
    isCountryCode = props.isCountryCode,
    isPlacePickerDropdown = props.isPlacePickerDropdown,
    holidayDropdown = props.holidayDropdown,
    fireGtm = props.fireGtm,
    isHotelSearchWidget = props.isHotelSearchWidget,
    isForListingPage = props.isForListingPage,
    holidayMobile = props.holidayMobile,
    cityLevelGrouping = props.cityLevelGrouping,
    enableOnChangeOnceEmpty = props.enableOnChangeOnceEmpty,
    move = props.move,
    enableSuggestion = props.enableSuggestion,
    inputId = props.inputId,
    isDepartReturnSame = props.isDepartReturnSame;
  var scrollToRef = function scrollToRef(itemList, newTop) {
    if (itemList && itemList.scrollTo) {
      itemList.scrollTo({
        behavior: 'smooth',
        top: newTop
      });
    }
  };
  var processScrollToItem = function processScrollToItem(itemListRef, highlightedItemIndex) {
    var itemList = itemListRef.current;
    if (itemList) {
      var maxItemsLength = Math.floor(_constant2.MAX_HEIGHT / (_constant2.SCROLL_SPACE + 2));
      var rangeItems = highlightedItemIndex - maxItemsLength;
      var fromTopPos = itemList.scrollTop;
      var toTopPos = fromTopPos + _constant2.MAX_HEIGHT - _constant2.SCROLL_SPACE;
      var currentTopPos = highlightedItemIndex * _constant2.SCROLL_SPACE;
      var supportToScroll = !(currentTopPos < toTopPos && currentTopPos > fromTopPos);
      if (supportToScroll) {
        var newTop = (currentTopPos > fromTopPos ? rangeItems + 1 : highlightedItemIndex) * _constant2.SCROLL_SPACE;
        scrollToRef(itemList, newTop);
      }
    }
  };
  var getFormattedValue = function getFormattedValue(obj) {
    if (cityLevelGrouping && obj && obj != null) {
      var _value = obj.StationType && obj.StationType === _constant2.CITY_CODE ? obj.CityName : obj.AirportName;
      return _value;
    }
    if (isDropdown && obj && obj != null && obj.name) {
      return obj.name;
    }
    if (obj && obj != null && obj.mainDisplayName) {
      return obj.mainDisplayName + (obj.airportCode ? " (".concat(obj.airportCode, ")") : '');
    }
    return '';
  };
  var dValue = '';
  if (defaultValue) {
    dValue = isNewVersion ? defaultValue : getFormattedValue();
  }
  var dropdownRef = _react.default.useRef(null);
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var _useState = (0, _react.useState)(dValue),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useState3 = (0, _react.useState)(defaultValue),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    tempValue = _useState4[0],
    setTempValue = _useState4[1];
  var _useState5 = (0, _react.useState)(items),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    options = _useState6[0],
    setOptions = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    noOptions = _useState8[0],
    setNoOptions = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
    showPopup = _useState10[0],
    setShowPopup = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
    isError = _useState12[0],
    setError = _useState12[1];
  var _useState13 = (0, _react.useState)(null),
    _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
    selectedValue = _useState14[0],
    setSelectedValue = _useState14[1];
  var selectedValueRef = (0, _react.useRef)(null);
  selectedValueRef.current = selectedValue;
  var _useState15 = (0, _react.useState)(isFocused),
    _useState16 = (0, _slicedToArray2.default)(_useState15, 2),
    focused = _useState16[0],
    setFocused = _useState16[1];
  var _useState17 = (0, _react.useState)(false),
    _useState18 = (0, _slicedToArray2.default)(_useState17, 2),
    showRecentSearches = _useState18[0],
    setShowRecentSearches = _useState18[1];
  var _useState19 = (0, _react.useState)(false),
    _useState20 = (0, _slicedToArray2.default)(_useState19, 2),
    showOptions = _useState20[0],
    setShowOptions = _useState20[1];
  var _useState21 = (0, _react.useState)(''),
    _useState22 = (0, _slicedToArray2.default)(_useState21, 2),
    formattedPlaceholder = _useState22[0],
    setFormattedPlaceholder = _useState22[1];
  var _useState23 = (0, _react.useState)(-1),
    _useState24 = (0, _slicedToArray2.default)(_useState23, 2),
    cursor = _useState24[0],
    setcursor = _useState24[1];
  var _useState25 = (0, _react.useState)(false),
    _useState26 = (0, _slicedToArray2.default)(_useState25, 2),
    showDestIMobile = _useState26[0],
    setShowDestInMobile = _useState26[1];
  var _useState27 = (0, _react.useState)(false),
    _useState28 = (0, _slicedToArray2.default)(_useState27, 2),
    isActiveNewVersion = _useState28[0],
    setisActiveNewVersion = _useState28[1];
  var _useState29 = (0, _react.useState)('bottom'),
    _useState30 = (0, _slicedToArray2.default)(_useState29, 2),
    optionPosition = _useState30[0],
    setOptionPosition = _useState30[1];
  var selectItemRef = _react.default.useRef();
  var tabIndex = !accessible ? '-1' : '0';
  var currentSuggestionRef = (0, _react.useRef)('');
  // eslint-disable-next-line no-unused-vars
  var _useState31 = (0, _react.useState)(false),
    _useState32 = (0, _slicedToArray2.default)(_useState31, 2),
    renderTrigger = _useState32[0],
    setRenderTrigger = _useState32[1];
  var updateCurrentSuggestion = function updateCurrentSuggestion(suggestion) {
    currentSuggestionRef.current = suggestion;
    setRenderTrigger(function (prev) {
      return !prev;
    }); // Trigger re-render
  };

  (0, _react.useEffect)(function () {
    setFocused(isFocused);
    if (viewPort !== 'mobile') {
      // eslint-disable-next-line no-unused-expressions
      /* istanbul ignore next */
      setTimeout(function () {
        if (isFocused && inputRef.current) {
          inputRef.current.focus();
        }
      }, 400);
    }
    // eslint-disable-next-line no-unused-expressions
  }, [inputRef, isFocused, viewPort]);
  (0, _react.useEffect)(function () {
    if (placeHolderItems && placeHolderItems.length > 0) {
      setFormattedPlaceholder(placeHolder.replace('{0}', "\"".concat(placeHolderItems[0], "\"")));
    } else {
      setFormattedPlaceholder(label);
    }
  }, [label, placeHolder, placeHolderItems]);
  (0, _react.useEffect)(function () {
    if (viewPort !== 'desktop') {
      setOptions(items);
      if (id !== _constant2.ORIGIN_ID) {
        setShowDestInMobile(true);
      }
    }
  }, [cityLevelGrouping, id, items, viewPort]);
  (0, _react.useEffect)(function () {
    var dafValue = '';
    if (defaultValue) {
      dafValue = isNewVersion ? defaultValue : getFormattedValue(defaultValue);
    }
    setValue(dafValue);
    setTempValue(defaultValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue, isNewVersion]);
  _react.default.useEffect(function () {
    if (selectItemRef.current) {
      processScrollToItem(selectItemRef, cursor);
    }
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  var reposition = function reposition() {
    if (dropdownRef.current) {
      var offset = _utilities.default.getElementOffset(dropdownRef.current);
      if (typeof window !== 'undefined') {
        if (window.innerHeight - offset.bottom < 100) {
          if (isDropdown && viewPort === 'mobile') {
            setOptionPosition('bottom');
          } else {
            setOptionPosition('top');
          }
        } else {
          setOptionPosition('bottom');
        }
      }
    }
  };
  (0, _react.useEffect)(function () {
    reposition();
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', reposition);
    }
    return function () {
      if (typeof window !== 'undefined') {
        window.addEventListener('resize', reposition);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dropdownRef]);
  var changeValueSuggestionCallback = function changeValueSuggestionCallback(inputValue) {
    return function (results) {
      if (results && results.length > 0) {
        setOptions(results);
        if (enableSuggestion) {
          onChange(inputValue, function (suggestions) {
            if ((suggestions === null || suggestions === void 0 ? void 0 : suggestions.length) > 0) {
              var trimInputValue = inputValue.trim().toLowerCase();
              var filteredSuggestions = suggestions.filter(function (suggestion) {
                var firstStation = suggestion.Stations && suggestion.Stations[0];
                var suggestionName = (firstStation === null || firstStation === void 0 ? void 0 : firstStation.AirportName.toLowerCase()) || '';
                return suggestionName.startsWith(trimInputValue);
              });
              if ((filteredSuggestions === null || filteredSuggestions === void 0 ? void 0 : filteredSuggestions.length) === 0) {
                updateCurrentSuggestion('');
              } else {
                var _filteredSuggestions$;
                var suggestion = "".concat((_filteredSuggestions$ = filteredSuggestions[0]) === null || _filteredSuggestions$ === void 0 || (_filteredSuggestions$ = _filteredSuggestions$.Stations[0]) === null || _filteredSuggestions$ === void 0 ? void 0 : _filteredSuggestions$.AirportName) || '';
                if (!suggestion.toLowerCase().startsWith(trimInputValue)) {
                  updateCurrentSuggestion('');
                } else {
                  updateCurrentSuggestion(String(suggestion));
                }
                setOptions(filteredSuggestions); // Ensure options are set to filtered suggestions
              }
            }
          });
        }
      } else {
        updateCurrentSuggestion('');
        setNoOptions(true);
      }
    };
  };
  var changeValueCallback = function changeValueCallback(results) {
    if (results && results.length > 0) {
      setOptions(results);
    } else {
      setNoOptions(true);
    }
  };
  var selectGroupOption = function selectGroupOption(index, loc) {
    var selectedOption = loc;
    var position = index + 1;
    if (selectedOption) {
      setSelectedValue(selectedOption);
      setValue(getFormattedValue(selectedOption));
      setTempValue(selectedOption);
      onSelect(selectedOption, position);
      setisActiveNewVersion(false);
      setShowOptions(false);
      if (viewPort === 'mobile') {
        setShowPopup(false);
        if (id !== _constant2.ORIGIN_ID) {
          setShowDestInMobile(true);
        }
        if (document.getElementsByTagName('body') && !isNewVersion && !isDropdown) document.getElementsByTagName('body')[0].style.overflow = 'hidden';
      }
    }
  };
  var selectOption = function selectOption(index) {
    var selectedOption = options[index];
    var position = index + 1;
    if (selectedOption) {
      setSelectedValue(selectedOption);
      setValue(getFormattedValue(selectedOption));
      setTempValue(selectedOption);
      onSelect(selectedOption, position);
      setisActiveNewVersion(false);
      setShowOptions(false);
      if (viewPort === 'mobile') {
        setShowPopup(false);
        if (id !== _constant2.ORIGIN_ID) {
          setShowDestInMobile(true);
        }
        if (document.getElementsByTagName('body') && !isNewVersion && !isDropdown) document.getElementsByTagName('body')[0].style.overflow = 'hidden';
        // if (document.getElementById('airasia-phoenix-modal-container'))
        //   document.getElementById('airasia-phoenix-modal-container').style.position = 'fixed';
      }
    }
  };

  var commonChangeHandler = function commonChangeHandler(inputValue) {
    setValue(inputValue);
    // TODO: you can add condition then only mark it false.
    setShowRecentSearches(false);
    setNoOptions(false);
  };
  var common = function common() {
    if (items && items.length > 0) {
      setOptions(items);
      setShowOptions(true);
      setShowRecentSearches(true);
    }
  };
  var onChangeHandler = function onChangeHandler(inputValue) {
    var trimInputValue = inputValue.trim();
    if (trimInputValue.length >= 1) {
      if (!showOptions) setShowOptions(true);
      if (selectedValue) setSelectedValue(null);
      setOptions([]);
      // eslint-disable-next-line no-unused-expressions
      isNewVersion ? onChange(inputValue, changeValueCallback, items) : enableSuggestion ? onChange(inputValue, changeValueSuggestionCallback(inputValue)) : onChange(inputValue, changeValueCallback);
    } else if (enableOnChangeOnceEmpty) {
      setSelectedValue(null); // remove selected item
      onSelect(null); // push null values for empty field
    } else if (isNewVersion) {
      setOptions(items);
      setShowOptions(true);
    } else {
      setShowOptions(false);
    }
  };
  var onKeydownHandler = function onKeydownHandler(e) {
    if (e.keyCode === 40) {
      if (options.length > 0 && cursor < options.length - 1) {
        setcursor(cursor + 1);
      }
    } else if (e.keyCode === 38) {
      if (cursor > 0) {
        setcursor(cursor - 1);
      }
    }
  };
  var onChangeHandlerForsingleCharacter = function onChangeHandlerForsingleCharacter(e) {
    var newValue = e.target.value;
    if (newValue === '' && onClear) {
      onClear();
    }
    setTimeout(function () {
      onChangeHandler(newValue);
    }, 0);
    commonChangeHandler(newValue);
  };
  var onChangeHandlerForMultiCharacter = function onChangeHandlerForMultiCharacter(e) {
    var newValue = e.target.value;
    if (newValue === '' && onClear) onClear();
    commonChangeHandler(newValue);
    if (newValue.length >= 3) {
      onChangeHandler(newValue);
    } else {
      // eslint-disable-next-line no-lonely-if
      if (showOptions) setShowOptions(false);
    }
  };
  var onClickHandlerMobile = function onClickHandlerMobile() {
    setShowPopup(true);
    if (id !== _constant2.ORIGIN_ID) setValue(null);
    common();
    if (document.getElementsByTagName('body')) document.getElementsByTagName('body')[0].style.overflow = 'auto';
    if (onClickCallback) onClickCallback();
    // if (document.getElementById('airasia-phoenix-modal-container'))
    //   document.getElementById('airasia-phoenix-modal-container').style.position = 'inherit';
    // setShowRecentSearches(true);
    // setShowOptions(true);
    // setOptions(props.items);
  };

  var onFocusHandler = function onFocusHandler(e) {
    e.target.select();
    setFocused(true);
    // setError(false);
    common();
    if (onFocus) onFocus(e);
  };
  var onKeyPressHandler = function onKeyPressHandler(e) {
    /* istanbul ignore next */
    if (e.key === 'Enter') {
      if (currentSuggestionRef.current && enableSuggestion) {
        setValue(currentSuggestionRef.current);
        setShowOptions(false);
      } else if (cursor >= 0 && showOptions) {
        selectOption(cursor);
        setShowOptions(false);
      } else {
        common();
        if (enableSuggestion) {
          setValue(value);
          onSelect(value);
        }
      }
    }
  };
  var onClickHandler = function onClickHandler() {
    if (enableSuggestion) {
      updateCurrentSuggestion('');
      if (value) {
        setShowOptions(true);
      }
      onChange(value, function (suggestions) {
        if ((suggestions === null || suggestions === void 0 ? void 0 : suggestions.length) > 0) {
          var _value$trim;
          var trimInputValue = value === null || value === void 0 || (_value$trim = value.trim()) === null || _value$trim === void 0 ? void 0 : _value$trim.toLowerCase();
          var filteredSuggestions = suggestions === null || suggestions === void 0 ? void 0 : suggestions.filter(function (suggestion) {
            var _firstStation$Airport;
            var firstStation = (suggestion === null || suggestion === void 0 ? void 0 : suggestion.Stations) && (suggestion === null || suggestion === void 0 ? void 0 : suggestion.Stations[0]);
            var suggestionName = (firstStation === null || firstStation === void 0 || (_firstStation$Airport = firstStation.AirportName) === null || _firstStation$Airport === void 0 ? void 0 : _firstStation$Airport.toLowerCase()) || '';
            return suggestionName === null || suggestionName === void 0 ? void 0 : suggestionName.startsWith(trimInputValue);
          });
          if ((filteredSuggestions === null || filteredSuggestions === void 0 ? void 0 : filteredSuggestions.length) > 0) {
            var _filteredSuggestions$2;
            var suggestion = "".concat((_filteredSuggestions$2 = filteredSuggestions[0]) === null || _filteredSuggestions$2 === void 0 || (_filteredSuggestions$2 = _filteredSuggestions$2.Stations[0]) === null || _filteredSuggestions$2 === void 0 ? void 0 : _filteredSuggestions$2.AirportName) || '';
            if (!(suggestion !== null && suggestion !== void 0 && suggestion.toLowerCase().startsWith(trimInputValue))) {
              updateCurrentSuggestion('');
            } else {
              updateCurrentSuggestion(String(suggestion));
            }
            setOptions(filteredSuggestions); // Ensure options are set to filtered suggestions
          }
        }
      });
    } else {
      common();
      if (onClickCallback) onClickCallback();
    }
  };
  (0, _react.useEffect)(function () {
    if (isDepartReturnSame) {
      setError(true);
    } else {
      setError(false);
    }
  }, [isDepartReturnSame]);
  var onBlurHandler = function onBlurHandler(e) {
    /* istanbul ignore next */
    if (isNewVersion && onBlur) {
      // `selectedValue`  from React state is always stale here
      // ...having a value of `null` even though it is fresh in other places
      // so onBlur is never called in here
      // so, we use a `ref` to ensure we get the freshest state value
      if (selectedValue || selectedValueRef.current) {
        onBlur(selectedValue || selectedValueRef.current);
      }
      if (autoSelectOneResult && value && options.length === 1) {
        selectOption(0);
      }
    } else {
      onBlur(e);
    }
    if (viewPort !== 'mobile') {
      setShowOptions(false);
      setFocused(false);
      setShowRecentSearches(false);
      if (enableSuggestion) {
        if (value === '') {
          return;
        }
        if (currentSuggestionRef.current && enableSuggestion) {
          if (autoSelectOneResult && value && options.length === 1) {
            selectOption(0);
            updateCurrentSuggestion('');
          }
          return;
        }
      }
      if (isDepartReturnSame) {
        setError(true);
      } else if (defaultValue !== null && getFormattedValue(defaultValue) === value) {
        setError(false);
        if (isValidField) isValidField(true);
      } else if (value && value.length === 0) {
        setError(true);
        if (isValidField) isValidField(false);
      } else if (selectedValue !== null && getFormattedValue(selectedValue) !== value) {
        setError(true);
        if (isValidField) isValidField(false);
      } else if (tempValue != null && value !== getFormattedValue(tempValue)) {
        setError(true);
        if (isValidField) isValidField(false);
      } else if (value.length > 0 && tempValue == null && selectedValue == null) {
        setError(true);
        if (isValidField) isValidField(false);
      }
    }
  };
  var backnavigationHandler = function backnavigationHandler() {
    setShowPopup(false);
    var formattedValue = getFormattedValue(tempValue);
    if (value !== formattedValue) {
      setValue(formattedValue);
    }
  };
  var isActive = alwaysShowLabel || focused || value;
  var getPlaceHolder = function getPlaceHolder() {
    var plcholder;
    if (value && value.length === 0) {
      plcholder = label;
    } else if (focused) {
      plcholder = formattedPlaceholder;
    } else {
      plcholder = label;
    }
    return plcholder;
  };
  var inputProps = _objectSpread({
    value: value,
    placeholder: getPlaceHolder(),
    label: label,
    tabIndex: tabIndex,
    className: className
  }, customProperties);
  var variant = '';
  if (focused && validateStatus === _constant2.VALIDATE_STATUS_ERROR) {
    variant = _constant2.INPUT_VARIANT.error;
  } else if (validateStatus) {
    variant = validateStatus;
  }

  // TODO: should keep condition for ent
  var noResultmsg = function noResultmsg() {
    var hotel = _constant2.CATEGORIES.hotel,
      snap = _constant2.CATEGORIES.snap,
      snapHotelSearchListing = _constant2.CATEGORIES.snapHotelSearchListing,
      hotelSearchListing = _constant2.CATEGORIES.hotelSearchListing;
    var gtmCategory = '';
    if (isHotelSearchWidget) {
      if (isForListingPage) gtmCategory = hotelSearchListing;else gtmCategory = hotel;
    }
    /* istanbul ignore next */
    if (!isHotelSearchWidget) {
      if (isForListingPage) gtmCategory = snapHotelSearchListing;else gtmCategory = snap;
    }
    var eventLabel = isHotelSearchWidget ? "".concat(value) : isForListingPage ? "".concat(value) : "".concat(id, "|").concat(value);
    var obj = (0, _gtmUtil.getDropDownGtmObject)(eventLabel, gtmCategory);
    if (obj && typeof fireGtm === 'function') fireGtm(obj, 'true');
    return isNewVersion ? locale.noRightKeywordLabel.replace('{0}', value) : locale.noResultLabel.replace('{0}', value);
  };
  var recentSearchMsg = locale.recentSearch;
  var returnIcon = function returnIcon(iconName, iconColor, accessibility) {
    return /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: accessibility || false,
      icon: iconName,
      fontsize: _constant2.ICON_STYLE.SIZE,
      color: iconColor || _constant2.ICON_STYLE.COLOR_DEFAULT,
      theme: theme
    });
  };
  var renderGroupedContent = function renderGroupedContent(item, index) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, index !== 0 && /*#__PURE__*/_react.default.createElement(Divider, null), /*#__PURE__*/_react.default.createElement(OptionDeep, {
      key: Math.random(),
      onMouseDown: function onMouseDown() {
        return selectGroupOption(index, item);
      },
      isActive: index === cursor,
      cityLevelGrouping: cityLevelGrouping,
      isCity: true
    }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(OptionLeft, null, /*#__PURE__*/_react.default.createElement(FlexWrapper, null, /*#__PURE__*/_react.default.createElement(OptionContentView, (0, _extends2.default)({
      item: item
    }, item, {
      inputValue: value,
      highlightText: highlightText,
      cityLevelGrouping: cityLevelGrouping,
      isCity: item && item.StationType === _constant2.CITY_CODE,
      locale: locale
    })))), /*#__PURE__*/_react.default.createElement(OptionRight, {
      cityLevelGrouping: cityLevelGrouping
    }, /*#__PURE__*/_react.default.createElement(OptionCityContent, null, item.StationType && item.StationType === _constant2.CITY_CODE ? item.CityCode : item.StationCode), item.rightIconName && returnIcon(item.rightIconName, item.color)))), item.Stations && item.Stations.map(function (loc, indexVal) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Divider, null), /*#__PURE__*/_react.default.createElement(OptionDeep, {
        key: Math.random(),
        onMouseDown: function onMouseDown() {
          return selectGroupOption(indexVal, loc);
        },
        isActive: indexVal === cursor,
        cityLevelGrouping: cityLevelGrouping,
        isCity: false
      }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(OptionLeft, null, /*#__PURE__*/_react.default.createElement(FlexWrapper, null, /*#__PURE__*/_react.default.createElement(OptionContentView, (0, _extends2.default)({
        item: loc
      }, loc, {
        inputValue: value,
        highlightText: highlightText,
        cityLevelGrouping: cityLevelGrouping
      })))), /*#__PURE__*/_react.default.createElement(OptionRight, {
        cityLevelGrouping: cityLevelGrouping
      }, loc.StationCode && /*#__PURE__*/_react.default.createElement(OptionCityContent, null, loc.StationCode), loc.rightIconName && returnIcon(loc.rightIconName, loc.color)))));
    }));
  };
  var shimmerLoading = function shimmerLoading() {
    return /*#__PURE__*/_react.default.createElement(LoadingOptions, {
      isNewVersion: isNewVersion
    }, noOptions ? noResultmsg() : /*#__PURE__*/_react.default.createElement(_ShimmerSsrExperience.default, {
      cards: 7,
      theme: theme,
      template: _constant.TEMPLATE.DROPDOWN
    }));
  };
  var loadOptions = function loadOptions() {
    if (showOptions) {
      if (options && options.length === 0 && value && !cityLevelGrouping) {
        return /*#__PURE__*/_react.default.createElement(OptionsContainer, {
          vwPort: viewPort,
          vWidth: width,
          isNewVersion: isNewVersion,
          cityLevelGrouping: cityLevelGrouping
        }, /*#__PURE__*/_react.default.createElement(LoadingOptions, {
          isNewVersion: isNewVersion,
          cityLevelGrouping: cityLevelGrouping,
          noOptions: noOptions
        }, /*#__PURE__*/_react.default.createElement(LoadingOptions, {
          isNewVersion: isNewVersion
        }, noOptions ? noResultmsg() : /*#__PURE__*/_react.default.createElement(_Spinner.default, {
          color: move && 'secondary'
        }))));
      }
      var SearchForMsg = locale.searchForLabel ? locale.searchForLabel.replace('{0}', value) : '';
      return /*#__PURE__*/_react.default.createElement(OptionsContainer, {
        vwPort: viewPort,
        vWidth: width,
        isNewVersion: isNewVersion,
        optionPosition: optionPosition,
        showOptionsfromTop: showOptionsfromTop,
        cityLevelGrouping: cityLevelGrouping
      }, showRecentSearches && !hideRecentLabel && items && items.length && !isNewVersion > 0 && /*#__PURE__*/_react.default.createElement(RecentSearches, {
        key: _constant2.RECENT_SEARCH_KEY,
        cityLevelGrouping: cityLevelGrouping
      }, recentSearchMsg), showSearchFor && SearchForMsg && value && /*#__PURE__*/_react.default.createElement(RecentSearches, {
        key: _constant2.RECENT_SEARCH_KEY
      }, SearchForMsg), cityLevelGrouping && options && options.length === 0 && value && shimmerLoading(), /*#__PURE__*/_react.default.createElement(OptionsWrapper, {
        key: "option-wrapper",
        recentSearches: showRecentSearches,
        vwPort: viewPort,
        isNewVersion: isNewVersion,
        vWidth: width,
        ref: selectItemRef,
        bgColor: backgroundColorItems,
        isDropdown: isDropdown,
        cityLevelGrouping: cityLevelGrouping,
        locale: locale
      }, options && options.map(function (item, index) {
        return /*#__PURE__*/_react.default.createElement(Option, {
          key: Math.random(),
          onMouseDown: function onMouseDown() {
            return !cityLevelGrouping && selectOption(index);
          },
          isActive: index === cursor,
          isNewVersion: isNewVersion,
          cityLevelGrouping: cityLevelGrouping
        }, cityLevelGrouping ? renderGroupedContent(item, index, locale) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(OptionLeft, null, /*#__PURE__*/_react.default.createElement(IconWrapper, null, returnIcon(isDropdown ? hotelIcon : item.iconName, item.color, accessible)), /*#__PURE__*/_react.default.createElement(OptionContentView, (0, _extends2.default)({}, item, {
          inputValue: value,
          highlightText: highlightText
        }))), /*#__PURE__*/_react.default.createElement(OptionRight, {
          cityLevelGrouping: cityLevelGrouping
        }, item.iconDisplayName && !isDropdown && /*#__PURE__*/_react.default.createElement(OptionSubContent, {
          icName: true
        }, item.iconDisplayName), isDropdown && /*#__PURE__*/_react.default.createElement(OptionSubRightContent, {
          icName: true,
          move: move
        }, item.iconDisplayName), item.rightIconName && returnIcon(item.rightIconName, item.color))), isNewVersion && selectedValue && item.value === selectedValue.mainDisplayName && !cityLevelGrouping || isNewVersion && item.value === tempValue && !cityLevelGrouping ? /*#__PURE__*/_react.default.createElement(OptionRight, {
          cityLevelGrouping: cityLevelGrouping
        }, returnIcon(_constant2.ICON_TYPE.CHECK, _constant2.ICON_STYLE.COLOR_TERTIARY, accessible)) : null);
      })));
    }
    return null;
  };
  var closeModal = function closeModal() {
    /* istanbul ignore next */
    setValue(null);
    setOptions(null);
    setShowPopup(false);
  };
  var onCancelSelectItem = function onCancelSelectItem() {
    /* istanbul ignore next */
    if (inputRef && inputRef.current && inputRef.current.value) {
      inputRef.current.value = '';
      inputRef.current.defaultValue = '';
    }
    setValue(null);
    if (isDropdown) {
      if (onSelect.length > 1) {
        onSelect(null, null);
      } else {
        onSelect(null);
      }
    }
    if (onClear) onClear();
  };
  var loadDropdownText = function loadDropdownText(isInpopup) {
    var _currentSuggestionRef;
    var inpProps = _objectSpread(_objectSpread({}, inputProps), {}, {
      onFocus: onFocusHandler,
      onBlur: onBlurHandler,
      onChange: supportOneCharacterSearch ? onChangeHandlerForsingleCharacter : onChangeHandlerForMultiCharacter,
      onKeyPress: onKeyPressHandler,
      onClick: onClickHandler,
      onKeyDown: onKeydownHandler,
      ref: inputRef,
      autoComplete: 'off',
      placeholder: inputProps.placeholder,
      autoFocus: viewPort !== 'desktop',
      isOnlyApplyForHotel: isOnlyApplyForHotel
    });
    var iconWrapperProps = {
      isActive: focused,
      isMobile: isInpopup,
      theme: theme
    };
    if (isInpopup) {
      iconWrapperProps.onClick = backnavigationHandler;
    }
    var handleActivateNewVersionDropdown = function handleActivateNewVersionDropdown() {
      setisActiveNewVersion(true);
      setFocused(true);
      if (tempValue && tempValue[customDisplayField]) {
        setValue(tempValue[customDisplayField]);
      }
      setTimeout(function () {
        return inputRef.current.focus();
      }, 0);
    };
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Wrapper, {
      error: isError,
      isActive: focused,
      isMobile: isInpopup,
      isNewVersion: isNewVersion,
      validateMessage: validateMessage,
      validateStatus: validateStatus,
      isActiveNewVersion: isActiveNewVersion,
      noneHighLight: noneHighLightInput,
      height: height,
      isDropdown: isDropdown,
      viewPort: viewPort,
      holidayDropdown: holidayDropdown,
      cityLevelGrouping: cityLevelGrouping,
      accessible: accessible
    }, (defaultIcon || isInpopup) && /*#__PURE__*/_react.default.createElement(IconWrapper, (0, _extends2.default)({}, iconWrapperProps, {
      showIconBackground: showIconBackground
    }), /*#__PURE__*/_react.default.createElement(CustomIcon, {
      isOnlyApplyForHotel: isOnlyApplyForHotel,
      isActive: focused,
      isMobile: isInpopup,
      accessible: false,
      icon: isDropdown && viewPort === 'mobile' ? '' : isInpopup ? _constant2.ICON_TYPE.BACK : defaultIcon,
      fontsize: _constant2.ICON_STYLE.SIZE
    })), /*#__PURE__*/_react.default.createElement(InputWrapper, {
      items: items,
      variant: variant
    }, isNewVersion ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(InputContent, {
      onClick: handleActivateNewVersionDropdown,
      tabIndex: isActive ? '-1' : tabIndex,
      onFocus: function onFocus() {
        return handleActivateNewVersionDropdown();
      }
    }, (isActive || tempValue || customDisplayValue === '') && /*#__PURE__*/_react.default.createElement(InputLabel, (0, _extends2.default)({
      isOnlyApplyForHotel: isOnlyApplyForHotel,
      variant: validateStatus,
      isNewVersion: isNewVersion,
      accessible: false,
      isDropdown: isDropdown
    }, isCountryCode && {
      textLimit: 11
    }), label), isActiveNewVersion ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledInput, (0, _extends2.default)({
      ref: inputRef
    }, inpProps, {
      defaultValue: customDisplayValue,
      accessible: true,
      tabIndex: tabIndex
      // onChange={inpProps.onChange}
    })), enableSuggestion && currentSuggestionRef.current && value && /*#__PURE__*/_react.default.createElement(SuggestionOverlay, null, /*#__PURE__*/_react.default.createElement("span", {
      style: {
        color: 'transparent'
      }
    }, value), /*#__PURE__*/_react.default.createElement("span", {
      style: {
        color: 'gray'
      }
    }, currentSuggestionRef.current.substring(value.length)))) : /*#__PURE__*/_react.default.createElement(_Text.default, {
      id: inputId,
      accessible: false,
      type: _constant2.TEXT_TYPE.DEFAULT,
      color: !value ? _constant2.TEXT_COLOR.GREY : _constant2.TEXT_COLOR.NEUTRAL,
      customProperties: _objectSpread(_objectSpread({}, customProperties), {}, {
        id: 'home_flyingfrom'
      })
    }, value || label)), !isInpopup ? /*#__PURE__*/_react.default.createElement(DropdownIcon, {
      onClick: handleActivateNewVersionDropdown
    }, returnIcon(isActiveNewVersion && showOptions ? _constant2.ICON_TYPE.EX_LESS : _constant2.ICON_TYPE.EX_MORE, _constant2.ICON_STYLE.COLOR, false)) : null) : /*#__PURE__*/_react.default.createElement(InputContent, null, isActive && !hideLabelWhenFocus && !isDropdown && /*#__PURE__*/_react.default.createElement(InputLabel, {
      isOnlyApplyForHotel: isOnlyApplyForHotel,
      variant: validateStatus
    }, label), /*#__PURE__*/_react.default.createElement(StyledInput, (0, _extends2.default)({
      ref: inputRef
    }, inpProps)), typeof currentSuggestionRef.current === 'string' && enableSuggestion && currentSuggestionRef.current && value && /*#__PURE__*/_react.default.createElement(SuggestionOverlay, null, /*#__PURE__*/_react.default.createElement("span", {
      style: {
        color: 'transparent'
      }
    }, value), /*#__PURE__*/_react.default.createElement("span", {
      style: {
        color: 'gray'
      }
    }, (_currentSuggestionRef = currentSuggestionRef.current) === null || _currentSuggestionRef === void 0 ? void 0 : _currentSuggestionRef.substring(value.length))))
    // {validateStatus === VALIDATE_STATUS_ERROR && validateMessage && (
    //   <ErrorMessage accessible={false}>{validateMessage}</ErrorMessage>
    // )}
    ), isShowCancel && !isInpopup && value && /*#__PURE__*/_react.default.createElement(CancelIconWrapper, (0, _extends2.default)({}, iconWrapperProps, {
      onClick: onCancelSelectItem,
      showIconBackground: showIconBackground
    }), /*#__PURE__*/_react.default.createElement(CustomIcon, {
      color: cancelIconColor,
      isOnlyApplyForHotel: isOnlyApplyForHotel,
      isActive: focused,
      isMobile: isInpopup,
      accessible: false,
      icon: _constant2.ICON_TYPE.CANCEL,
      fontsize: _constant2.ICON_STYLE.SIZE,
      move: move
    }))));
  };
  var loadMobileDropdownTextField = function loadMobileDropdownTextField() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Wrapper, {
      isNewVersion: isNewVersion,
      isOnlyApplyForHotel: isOnlyApplyForHotel,
      validateMessage: validateMessage,
      validateStatus: validateStatus,
      holidayDropdown: holidayDropdown,
      viewPort: viewPort,
      holidayMobile: holidayMobile,
      cityLevelGrouping: cityLevelGrouping
    }, !hideMobileIcon && defaultIcon && !isDropdown && /*#__PURE__*/_react.default.createElement(IconWrapper, {
      isActive: focused
    }, /*#__PURE__*/_react.default.createElement(CustomIcon, {
      isMobile: true,
      accessible: accessible,
      icon: defaultIcon,
      fontsize: _constant2.ICON_STYLE.SIZE
    })), /*#__PURE__*/_react.default.createElement(InputWrapper, {
      variant: variant,
      onClick: onClickHandlerMobile
    }, /*#__PURE__*/_react.default.createElement(InputContent, null, value && !hideLabelWhenFocus && !isDropdown && /*#__PURE__*/_react.default.createElement(InputLabel, (0, _extends2.default)({
      variant: validateStatus
    }, isCountryCode && {
      textLimit: 11
    }), label), isNewVersion || isDropdown ? /*#__PURE__*/_react.default.createElement(MobileV2Text, {
      hasValue: !(value === '' || value === null),
      allowPlaceholderColorMobile: allowPlaceholderColorMobile,
      color: !value ? _constant2.TEXT_COLOR.GREY : _constant2.TEXT_COLOR.NEUTRAL
    }, id === _constant2.DESTI_ID ? value || label : (id === _constant2.ORIGIN_ID ? value : (showDestIMobile || qpSyncStations) && value) || label) : /*#__PURE__*/_react.default.createElement(MobileText, {
      hasValue: value !== '',
      isOnlyApplyForHotel: isOnlyApplyForHotel,
      allowPlaceholderColorMobile: allowPlaceholderColorMobile,
      color: !value ? _constant2.TEXT_COLOR.GREY : _constant2.TEXT_COLOR.NEUTRAL,
      isDropdown: isDropdown,
      cityLevelGrouping: cityLevelGrouping
    }, id === _constant2.DESTI_ID ? value || label : (id === _constant2.ORIGIN_ID ? value : (showDestIMobile || qpSyncStations) && value) || label)), !isDropdown && !holidayDropdown && /*#__PURE__*/_react.default.createElement(DropdownIcon, null, returnIcon(isActiveNewVersion && showOptions ? _constant2.ICON_TYPE.EX_LESS : _constant2.ICON_TYPE.EX_MORE, _constant2.ICON_STYLE.COLOR, false))), isShowCancel && !hideMobileIcon && value && /*#__PURE__*/_react.default.createElement(CancelIconWrapper, {
      onClick: onCancelSelectItem,
      showIconBackground: showIconBackground
    }, /*#__PURE__*/_react.default.createElement(CustomIcon, {
      color: cancelIconColor,
      isOnlyApplyForHotel: isOnlyApplyForHotel,
      isActive: focused,
      accessible: false,
      icon: _constant2.ICON_TYPE.CANCEL,
      fontsize: _constant2.ICON_STYLE.SIZE
    }))));
  };
  var loadPopup = function loadPopup() {
    return !isDropdown ? /*#__PURE__*/_react.default.createElement(MobilePopup, {
      isNewVersion: isNewVersion,
      isDropdown: isDropdown
    }, /*#__PURE__*/_react.default.createElement(PopupHeader, {
      isDropdown: isDropdown,
      isPlacePickerDropdown: isPlacePickerDropdown
    }, loadDropdownText(true)), loadOptions(props, true)) : /*#__PURE__*/_react.default.createElement(_Modal.default, {
      title: locale.searchByPropertyName,
      onClose: closeModal,
      fullScreen: true,
      showCloseIcon: false,
      alignCloseBtn: "left",
      zIndex: "999999",
      isDropdown: true
    }, /*#__PURE__*/_react.default.createElement(MobilePopup, {
      isNewVersion: isNewVersion,
      isDropdown: isDropdown
    }, /*#__PURE__*/_react.default.createElement(PopupHeader, {
      isDropdown: isDropdown
    }, loadDropdownText(true)), loadOptions(props, true)));
  };
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(Main, {
      vwPort: viewPort,
      vWidth: width,
      id: id,
      mWidth: mWidth,
      isNewVersion: isNewVersion,
      ref: dropdownRef
    }, viewPort === 'desktop' && loadDropdownText(false), viewPort === 'desktop' && loadOptions(props, false, true), viewPort !== 'desktop' && !showPopup && loadMobileDropdownTextField(props), viewPort !== 'desktop' && showPopup && loadPopup(props), isNewVersion && validateMessage && validateStatus === _constant2.VALIDATE_STATUS_ERROR ? /*#__PURE__*/_react.default.createElement(ErrorMessage, {
      accessible: false
    }, validateMessage) : null);
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
Dropdown.propTypes = _Dropdown.default.PropTypes;
Dropdown.defaultProps = _Dropdown.default.DefaultProps;
var _default = Dropdown;
exports.default = _default;